const LogoMark = ({ size = 36 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <rect width="64" height="64" rx="12" fill="#141916" />
        <circle cx="30" cy="34" r="20" stroke="#F27A23" strokeWidth="3" />
        <circle cx="30" cy="34" r="13" stroke="#9EAEA2" strokeWidth="2" />
        <circle cx="30" cy="34" r="6" fill="#F27A23" />
        <path d="M44 10 L58 18 L44 24 Z" fill="#F27A23" />
        <rect
            x="47"
            y="4"
            width="4"
            height="4"
            fill="#9EAEA2"
            transform="rotate(20 49 6)"
        />
    </svg>
);

const Logo = ({ light = true, size = 36 }) => (
    <span className="inline-flex items-center gap-3">
        <LogoMark size={size} />
        <span className="leading-none text-left">
            <span
                className={`block font-display uppercase tracking-wide text-lg ${
                    light ? "text-brand-cream" : "text-brand-ink"
                }`}
                style={{ fontWeight: 800 }}
            >
                Southeast
            </span>
            <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-brand-amber">
                Stump Grinding
            </span>
        </span>
    </span>
);

export default Logo;
